<!-- eslint-disable @libui/link-incompatible-attributes -->
<template>
  <ux-container
    v-if="store.isDisplayResult"
    id="results"
    space-v="md"
    no-padding
    radius-none
  >
    <ux-section
      class="info"
      space-v="xxs"
      tag="div"
    >
      <ux-text tag="p">
        Le contrat susvisé promeut des caractéristiques environnementales ou sociales en proposant notamment une ou
        plusieurs unités de compte soumises aux exigences de l’article 8 ou de l’article 9 du règlement (UE) 2019/2088.
        Ce contrat référence par ailleurs des supports en unités de compte labellisés dont a minima une unité de compte
        de chacun des labels suivants : ISR, Greenfin et Finansol.
      </ux-text>
      <ux-text
        class=""
        tag="p"
      >
        Ce contrat est soumis aux exigences de l’article 8 du règlement (UE) 2019/2088 sur la publication d’informations
        en matière de durabilité dans le secteur des services financiers.
      </ux-text>
      <ux-text
        class=""
        tag="p"
      >
        Des informations sur la promotion des caractéristiques environnementales ou sociales des contrats
        d'assurance-vie et de capitalisation gérés par Suravenir ainsi que sur les labels des supports d'investissement
        sont disponibles sur la page internet :
        <ux-link-blank lib-link="https://www.suravenir.fr/assureur-responsable-et-engage/"
          >https://www.suravenir.fr/assureur-responsable-et-engage/</ux-link-blank
        >
      </ux-text>
    </ux-section>
    <ux-card-body>
      <ux-accordion-item
        v-if="selectedProduct"
        expanded
      >
        <ux-text
          slot="accordion-header"
          tag="p"
          class="accordion-title"
          left
          >Contrat</ux-text
        >
        <ux-flex class="row-header">
          <ux-text
            tag="span"
            class="long-col"
            >Libellé</ux-text
          >
          <ux-text tag="span"></ux-text>
          <ux-text tag="span"></ux-text>
          <ux-text tag="span"></ux-text>
          <ux-text tag="span"></ux-text>
          <ux-text tag="span"></ux-text>
          <ux-text
            tag="span"
            class="short-col tooltip"
            >DIC *<span class="tooltiptext">Document d'informations clés</span></ux-text
          >
          <ux-text
            tag="span"
            class="short-col tooltip"
            >Infos générales durabilité *<span class="tooltiptextleft"
              >Publication d’informations en matière de durabilité
            </span></ux-text
          >
        </ux-flex>
        <ux-flex class="row">
          <ux-text
            tag="span"
            class="long-col"
            >{{ selectedProduct.productName }}</ux-text
          >
          <ux-text tag="span"></ux-text>
          <ux-text tag="span"></ux-text>
          <ux-text tag="span"></ux-text>
          <ux-text tag="span"></ux-text>
          <ux-text tag="span"></ux-text>
          <ux-text
            tag="span"
            class="short-col"
          >
            <ux-shortlink
              v-if="selectedProduct.documentUrl"
              :lib-link="selectedProduct.documentUrl"
              icon="telecharger"
              a11y-label="Télécharger DIC"
            >
            </ux-shortlink>
          </ux-text>
          <ux-text tag="span"></ux-text>
        </ux-flex>
      </ux-accordion-item>
      <ux-accordion-item
        v-if="selectedMandats.length"
        expanded
      >
        <ux-text
          slot="accordion-header"
          tag="p"
          class="accordion-title"
          left
          >Mandats d'arbitrage</ux-text
        >
        <ux-flex
          class="row-header"
          style="line-height: 42px"
        >
          <ux-text
            tag="span"
            class="long-col"
            >Libellés</ux-text
          >
          <ux-text tag="span">Codes</ux-text>
          <ux-text
            tag="span"
            class="short-col"
          ></ux-text>
          <ux-text
            tag="span"
            class="short-col"
          ></ux-text>
          <ux-text
            tag="span"
            class="short-col"
          ></ux-text>
          <ux-text
            tag="span"
            class="short-col"
          ></ux-text>
          <ux-text
            tag="span"
            class="short-col"
          ></ux-text>
          <ux-text
            tag="span"
            class="short-col tooltip"
            >DIS *<span class="tooltiptext">Document d'informations spécifiques </span></ux-text
          >
          <ux-text tag="span"></ux-text>
        </ux-flex>
        <ux-flex
          v-for="infosProduct in selectedMandats"
          :key="infosProduct.name"
          nowrap
          class="row"
        >
          <ux-text
            tag="span"
            class="long-col"
            >{{ infosProduct.name }}</ux-text
          >
          <ux-text tag="span">{{ infosProduct.isin }}</ux-text>
          <ux-text
            tag="span"
            class="short-col"
          ></ux-text>
          <ux-text
            tag="span"
            class="short-col"
          ></ux-text>
          <ux-text
            tag="span"
            class="short-col"
          ></ux-text>
          <ux-text
            tag="span"
            class="short-col"
          ></ux-text>
          <ux-text
            tag="span"
            class="short-col"
          ></ux-text>
          <ux-text
            tag="span"
            class="short-col"
          >
            <ux-shortlink
              v-if="infosProduct.documentUrl"
              :lib-link="infosProduct.documentUrl"
              icon="telecharger"
              a11y-label="Télécharger DIS"
            >
            </ux-shortlink>
          </ux-text>
          <ux-text tag="span"></ux-text>
        </ux-flex>
      </ux-accordion-item>
      <ux-accordion-item
        v-if="selectedGestion.length"
        expanded
      >
        <ux-text
          slot="accordion-header"
          tag="p"
          class="accordion-title"
          left
          >Gestion profilée</ux-text
        >
        <ux-flex class="row-header">
          <ux-text tag="span">Codes</ux-text>
          <ux-text
            tag="span"
            class="long-col"
            >Libellé</ux-text
          >
          <ux-text tag="span"></ux-text>
          <ux-text tag="span"></ux-text>
          <ux-text tag="span"></ux-text>
          <ux-text tag="span"></ux-text>
          <ux-text
            tag="span"
            class="short-col"
            >DIS *<span class="tooltiptext">Document d'informations spécifiques </span></ux-text
          >
          <ux-text tag="span"></ux-text>
        </ux-flex>
        <ux-flex
          v-for="infosProduct in selectedGestion"
          :key="infosProduct.name"
          nowrap
          class="row"
        >
          <ux-text tag="span">{{ infosProduct.isin }}</ux-text>
          <ux-text
            tag="span"
            class="long-col"
            >{{ infosProduct.name }}</ux-text
          >
          <ux-text tag="span"></ux-text>
          <ux-text tag="span"></ux-text>
          <ux-text tag="span"></ux-text>
          <ux-text tag="span"></ux-text>
          <ux-text
            tag="span"
            class="short-col"
          >
            <ux-shortlink
              v-if="infosProduct.documentUrl"
              :lib-link="infosProduct.documentUrl"
              icon="telecharger"
              a11y-label="Télécharger DIS"
            >
            </ux-shortlink>
          </ux-text>
          <ux-text tag="span"></ux-text>
        </ux-flex>
      </ux-accordion-item>
      <ux-accordion-item
        v-if="selectedSupports.length"
        expanded
      >
        <ux-text
          slot="accordion-header"
          class="accordion-title"
          left
          >Supports</ux-text
        >
        <ux-flex class="row-header">
          <ux-text tag="span">Code ISIN</ux-text>
          <ux-text
            tag="span"
            class="short-col"
            >Catégorie</ux-text
          >
          <ux-text
            tag="span"
            class="long-col"
            >Libellé code ISIN</ux-text
          >
          <ux-text
            tag="span"
            class="short-col tooltip"
            >DIC/DIS *<span class="tooltiptext"
              >Document d'informations clés/Document d'informations spécifiques
            </span></ux-text
          >
          <ux-text tag="span">Label(s)</ux-text>
          <ux-text tag="span">Classification SFDR</ux-text>
          <ux-text
            tag="span"
            class="short-col tooltip"
            >PCD *<span class="tooltiptext">Annexes précontractuelles Règlement SFDR</span></ux-text
          >
          <ux-text
            tag="span"
            class="short-col tooltip"
            >PR *<span class="tooltiptext">Rapports périodiques Règlement SFDR</span></ux-text
          >
          <ux-text
            tag="span"
            class="short-col tooltip"
            >Infos générales durabilité *<span class="tooltiptextleft"
              >Publication d’informations en matière de durabilité
            </span></ux-text
          >
        </ux-flex>
        <ux-flex
          v-for="infosProduct in selectedSupports"
          :key="infosProduct.name"
          nowrap
          class="row"
        >
          <ux-text tag="span">{{ infosProduct.isin }}</ux-text>
          <ux-text
            tag="span"
            class="short-col capitalize"
            >{{ formatData(infosProduct.nature) }}</ux-text
          >
          <ux-text
            tag="span"
            class="long-col"
            >{{ infosProduct.name }}</ux-text
          >
          <ux-text
            tag="span"
            class="short-col"
          >
            <ux-shortlink
              v-if="infosProduct.documentUrl"
              :lib-link="infosProduct.documentUrl"
              icon="telecharger"
              a11y-label="Télécharger DIS"
            >
            </ux-shortlink>
          </ux-text>
          <ux-text tag="span">{{ formatLabel(infosProduct.financialInstrumentEsgLabelOrStandard) }}</ux-text>
          <ux-text tag="span">{{ formatClassification(infosProduct.financialInstrumentSfdrProductType) }}</ux-text>
          <ux-text
            tag="span"
            class="short-col"
          >
            <ux-shortlink
              v-if="infosProduct.pcdDocumentUrl"
              :lib-link="infosProduct.pcdDocumentUrl"
              icon="telecharger"
              a11y-label="Télécharger DIS"
            >
            </ux-shortlink>
          </ux-text>
          <ux-text
            tag="span"
            class="short-col"
          >
            <ux-shortlink
              v-if="infosProduct.prDocumentUrl"
              :lib-link="infosProduct.prDocumentUrl"
              icon="telecharger"
              a11y-label="Télécharger PR"
            >
            </ux-shortlink>
          </ux-text>
          <ux-text
            tag="span"
            class="short-col"
          >
            <ux-shortlink
              v-if="infosProduct.financialInstrumentLinkToSfdrWebsiteProductDisclosures"
              :lib-link="infosProduct.financialInstrumentLinkToSfdrWebsiteProductDisclosures"
              icon="telecharger"
              a11y-label="Télécharger DIS"
            >
            </ux-shortlink>
          </ux-text>
        </ux-flex>
      </ux-accordion-item>
    </ux-card-body>
  </ux-container>
</template>

<script lang="ts">
import { defineComponent } from 'vue'

import type { Underlying } from '@/types'

import { store } from '../store/Store'
import { labelize } from '../services/TranscoService'

export default defineComponent({
  data() {
    return {
      store: store(),
    }
  },
  computed: {
    selectedProduct() {
      return store().product
    },
    selectedMandats(): Underlying[] {
      const { selectedDocuments } = store()
      return selectedDocuments.filter((data) => data.nature == 'MANDATS')
    },
    selectedGestion(): Underlying[] {
      const { selectedDocuments } = store()
      return selectedDocuments.filter((data) => data.nature == 'GESTION_PILOTEE')
    },
    selectedSupports(): Underlying[] {
      const { selectedDocuments } = store()
      return selectedDocuments
        .filter((data) => data.nature != 'MANDATS' && data.nature != 'GESTION_PILOTEE')
        .sort((a: Underlying, b: Underlying) => this.isinSort(a, b))
    },
    supports(): Underlying[] {
      const { documents } = store()
      return documents.filter((data) => data.nature != 'MANDATS' && data.nature != 'GESTION_PILOTEE')
    },
  },
  methods: {
    formatData(nature: string | null): string {
      if (nature) {
        return nature.replace(/_/g, ' ').toLowerCase()
      }
      return ''
    },
    formatLabel(codeLabel: string | null) {
      if (codeLabel !== null) {
        return labelize(codeLabel)
      }
      return codeLabel
    },
    formatClassification(codeClassification: number | string | null) {
      if (codeClassification === null || codeClassification === 0) {
        return 'N.C'
      }
      return codeClassification
    },
    isinSort(a: Underlying, b: Underlying) {
      const textA = a.isin.toUpperCase()
      const textB = b.isin.toUpperCase()
      return textA < textB ? -1 : textA > textB ? 1 : 0
    },
  },
})
</script>

<style scoped>
ux-card-body ux-text {
  width: 10%;
  padding-top: 15px;
}

ux-section.info {
  padding-top: 20px;
  padding-bottom: 10px;
  padding-left: 10px;
  margin-bottom: 0px;
}

ux-accordion-item {
  width: 100%;
}

ux-accordion-item ux-flex ux-text {
  width: 11%;
}

.row-header {
  background-color: #d42d2e;
  color: white;
  font-weight: bold;
  text-align: center;
  min-height: 52px;
}

.row {
  padding-bottom: 10px;
  padding-top: 10px;
  border-bottom: 1px solid #707070;
  min-height: 60px;
  text-align: center;
}

ux-container#results ux-flex ux-text {
  padding: 5px;
}

.long-col {
  width: 20%;
}

.short-col {
  width: 9%;
}

.accordion-title {
  width: 100%;
  padding-left: 10px;
}

.tooltip {
  position: relative;
  display: inline-block;
}

.tooltip .tooltiptext {
  visibility: hidden;
  font-weight: normal;
  line-height: normal;
  background-color: rgb(48, 48, 48);
  color: #ffffff;
  text-align: center;
  opacity: 90;
  border-radius: 6px;
  padding: 20px;
  /* Position the tooltip */
  position: absolute;
  z-index: 1000;
}
.tooltip .tooltiptextleft {
  visibility: hidden;
  font-weight: normal;
  line-height: normal;
  background-color: rgb(48, 48, 48);
  color: #ffffff;
  text-align: center;
  opacity: 90;
  border-radius: 6px;
  padding: 20px;
  /* Position the tooltip */
  position: absolute;
  z-index: 1000;
  right: 90px;
  top: 20px;
}

.tooltip:hover :is(.tooltiptext, .tooltiptextleft) {
  visibility: visible;
}
</style>
